<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Questions List">
        <br />
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center" style="width:3%">S.NO</b-th>
              <b-th class="text-center" style="width:500px">Questions</b-th>
              <b-th class="text-center">Correct Answer</b-th>
              <b-th class="text-center">User Answer</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
           <b-tr v-for="(result, index) in results" :key="index">
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
              <b-td class="text-center">
                {{ result.questions.question }}
              </b-td>
               <b-td class="text-center">
                {{ result.questions.answer }}
              </b-td>
              <b-td class="text-center">{{ result.answer }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  mounted() {
    this.getResults();
  },
  methods: {
    async getResults() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/tests-answers/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.results = response.data.answer_lists;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
  data() {
    return {
      results: [],
    };
  },
};
</script>
 